export default __webpack_public_path__ + "static/media/department_of_state_USA.fd600dd1.png";